import type { ReactElement } from "react"
import React, { useState } from "react"
import { uniqBy } from "lodash"
import ButtonAtm from "@onestore/hel/dist/components/atoms/ButtonAtm"
import BarOrg from "@onestore/hel/dist/components/organisms/BarOrg"
import GridOrg from "@onestore/hel/dist/components/organisms/GridOrg"
import OverlayContainerOrg, {
  headerTypes,
  sizes,
  startPositions,
} from "@onestore/hel/dist/components/organisms/OverlayContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import MarkdownTitle from "@gatsby-plugin-generic-page/components/Markdown/Title"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import LabeledToggleSwitch from "~/components/LabeledToggleSwitch"
import { findDeep } from "~/lib/findDeep"
import isEmpty from "~/lib/isEmpty"
import { useSquidexAssetsQuery } from "~/lib/squidex"
import AssetRow from "./AssetRow"

type PageAsset = {
  id: string
  url?: string
  alt?: string
  type: string
}
export default function SquidexA11yToolbar({ page }): ReactElement | null {
  const [isOpen, setIsOpen] = useState(false)
  const [showOnlyEmpty, setshowOnlyEmpty] = useState(true)

  const assets = uniqBy<PageAsset>(
    findDeep<PageAsset>(page, (object: PageAsset): boolean => {
      return (
        object.hasOwnProperty("url") &&
        object.hasOwnProperty("alt") &&
        object.hasOwnProperty("title") &&
        object.hasOwnProperty("type") &&
        object.type !== "VIDEO"
      )
    }),
    "id"
  )

  const assetsResponse = useSquidexAssetsQuery(assets.map((asset) => asset.id))

  if (process.env.GATSBY_SQUIDEX_TOOLBAR !== "true") {
    return null
  }

  if (assetsResponse.isLoading) {
    return (
      <div style={{ position: "fixed", bottom: 0, left: 0, zIndex: 9999 }}>
        <BarOrg color="errorLight">
          <ButtonAtm isLoading={true} title={"Wczytywanie"}>
            Wczytywanie
          </ButtonAtm>
        </BarOrg>
      </div>
    )
  }

  const emptyAssets = assetsResponse.data?.data.items.filter((asset) => {
    return isEmpty(asset?.metadata?.alt) || isEmpty(asset?.metadata?.title)
  })

  if (!emptyAssets || emptyAssets.length === 0) {
    return null
  }

  return (
    <>
      {isOpen ? (
        <OverlayContainerOrg
          startPosition={startPositions.RIGHT}
          size={sizes.LARGE}
          headerType={headerTypes.SHADOWED}
          onCloseButtonClick={() => {
            setIsOpen(false)
          }}
          header={
            <PushOrg>
              <GridOrg gutterSpace={1} columns={2}>
                <MarkdownTitle
                  overrides={getBaseMarkdownOverrides({
                    typography: "large2",
                  })}
                >
                  Aktualizacja opisów grafik na stronie
                </MarkdownTitle>

                <LabeledToggleSwitch
                  id={"toggle-a11y-assets-switch"}
                  onClick={() => {
                    setshowOnlyEmpty(!showOnlyEmpty)
                  }}
                  isChecked={showOnlyEmpty}
                  label={"Pokazuj zaktualizowane"}
                />
              </GridOrg>
            </PushOrg>
          }
        >
          {emptyAssets.map((asset) => (
            <AssetRow
              showOnlyEmpty={showOnlyEmpty}
              key={asset.id}
              asset={asset}
            />
          ))}
        </OverlayContainerOrg>
      ) : null}

      <div style={{ position: "fixed", bottom: 0, left: 0, zIndex: 9999 }}>
        <BarOrg color="errorLight">
          <ButtonAtm
            title="Uzupełnij brakujące opisy"
            color="error"
            size="small"
            onClick={() => {
              setIsOpen(true)
            }}
          >
            Uzupełnij {emptyAssets.length} brakujących opisów grafik na stronie
          </ButtonAtm>
        </BarOrg>
      </div>
    </>
  )
}
